import type { UntitledIconData } from '../../UntitledIconData'

const ulMinusCircle: UntitledIconData = {
  prefix: 'ul',
  name: 'minus-circle',
  paths: [
    {
      shape:
        'M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z',
    },
  ],
}

export default ulMinusCircle
